<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
  import constants from "../../constants";
  import authenService from "../../services/authenService";
  // import {refreshTokenBeforeRedirect} from "../../services/refreshTokenUtils";

  export default {
    name: "Login",

    mounted() {
      this.clearStorage();
      this.redirectToSSOPage();
    },

    methods: {
      clearStorage() {
        // authenService.remove(constants.STORAGE_KEY.USER_DEPT_ROLE_ID);
        authenService.remove(constants.STORAGE_KEY.DEPT_CODE);
        authenService.remove(constants.STORAGE_KEY.ROLE_CODE);
      },

      redirectToSSOPage() {
        // refreshTokenBeforeRedirect();
        let response_type = encodeURIComponent("id_token token");
        let scope = encodeURIComponent("openid");
        let nonce = encodeURIComponent("anything");

        let stateBeforeRedirect = JSON.parse(
          authenService.get(constants.STATE_URL_BEFORE_LOGIN)
        );
        let state = !stateBeforeRedirect
          ? encodeURIComponent("anything")
          : encodeURIComponent(stateBeforeRedirect.ID);

        let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
        let redirect_uri = encodeURIComponent(constants.SSO_LOGIN_CALLBACK);
        let tenantCode = '';
        if(window.location.hostname) {
            tenantCode = window.location.hostname.split('.')[0];
        }
        // if(window.location.pathname) {
        //     tenantCode = window.location.pathname.split('/')[1];
        // }

        console.log(tenantCode);
        window.location.href = `${// constants.BASE_SERVICE_DOMAIN +tenantCode+'.'+
          constants.SSO_URL
        }?response_type=${response_type}&scope=${scope}&nonce=${nonce}&state=${state}&client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}`;
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/login/Login.vue